export default __webpack_public_path__ + "src/images/packages/marataba-conservation-camps/c502356f25935e8e0476d2ae7b4d05fb-5.jpg";